import React from 'react';
import { connect } from 'react-redux';
import _ from 'lodash';
import * as actions from '../../../../redux/projects/actions.projects';
import messages from '../../../../const/messages';
import { TEXT_CHAT_ENABLED_KEY, DEFAULT_ALAN_BTN_SIZE, TEXT_CHAT_BUBBLES_REQUEST_BACKGROUND_COLOR_KEY, TEXT_CHAT_BUBBLES_RESPONSE_FONT_COLOR_KEY, TEXT_CHAT_POPUP_FULL_SCREEN_MODE_ENABLED_KEY, getDefaultOptionsValue } from '../defaultProjectOptions';
import { getBoolOption, getStringOption } from '../getProjectOptions';
import { ColorPicker } from '../../../components/ColorPicker/ColorPicker';
import Slider from '../../../components/Slider/Slider';
import cancelEvent from '../../../../services/mini/cancelEvent';
import ToasterService from '../../../../services/ToasterService';
import { DEFAULT_BTN_LOGO, MIC_BTN_LOGO, USER_AVATAR_LOGO } from '../../../../const/defaultButtonLogos';
import platformNames from '../../../../const/platformNames';
import asyncDispatch from '../../../../services/mini/asyncDispatch';
import { getProjectOptionsByEnvironment } from '../../../../services/mini/getProjectOptionsByEnvironment';
import ReactTooltip from 'react-tooltip';
import capitalize from '../../../../services/mini/capitalize';
import $ from 'jquery';

let defaultOptions = require('../../../../../alanBtnJsonSettings/default.json');

const BTN_SIZE_SLIDER_OPTIONS = [32, 0, 0, 0, 64, 0, 0, 0, 96];

const IDLE_STATE = 'idle';
const LISTEN_STATE = 'listen';
const PROCESS_STATE = 'process';
const REPLY_STATE = 'reply';
const TEXT_CHAT_STATE = 'textChat';
const TEXT_CHAT_AVATAR_STATE = 'textChatAvatar';
const TEXT_CHAT_USER_AVATAR_STATE = 'textChatUserAvatar';


class AlanButtonStyleForm extends React.Component {
    constructor(props, context) {
        super(props, context);

        const { project, platform, environment, cohorts, selectedCohortId, currentOptions } = props;
        const options = currentOptions;


        this.state = {
            btnStyles: [],
            selectedBtnStyleId: this.getSelectedBtnStyleId(this.props),
            ...this.getButtonSettings(options, platform),
            [TEXT_CHAT_ENABLED_KEY]: getBoolOption(props, TEXT_CHAT_ENABLED_KEY),
            [TEXT_CHAT_BUBBLES_REQUEST_BACKGROUND_COLOR_KEY]: getStringOption(props, TEXT_CHAT_BUBBLES_REQUEST_BACKGROUND_COLOR_KEY),
            [TEXT_CHAT_BUBBLES_RESPONSE_FONT_COLOR_KEY]: getStringOption(props, TEXT_CHAT_BUBBLES_RESPONSE_FONT_COLOR_KEY),
            [TEXT_CHAT_POPUP_FULL_SCREEN_MODE_ENABLED_KEY]: getBoolOption(props, TEXT_CHAT_POPUP_FULL_SCREEN_MODE_ENABLED_KEY),
            // state for ui
            currentColorPicker: '',
            idleColorPicker1Shown: false,
            idleColorPicker2Shown: false,
            listenColorPicker1Shown: false,
            listenColorPicker2Shown: false,
            processColorPicker1Shown: false,
            processColorPicker2Shown: false,
            replyColorPicker1Shown: false,
            replyColorPicker2Shown: false,
            textChatColorPicker1Shown: false,
            textChatColorPicker2Shown: false,
            textChatAvatarColorPicker1Shown: false,
            textChatAvatarColorPicker2Shown: false,
            textChatUserAvatarColorPicker1Shown: false,
            textChatUserAvatarColorPicker2Shown: false,
            showOnBackBtnDialog: false,
            showDeleteStyleDialog: false,
            showOnStyleChangeDialog: false,
            showSaveBtnOptionsStyleDialog: false,
            uploadingLogo: false,
            optionsItemForDeleting: {},
        };

        this.saveBtnOptionsStylePromiseResolve = null;
        this.fileInput = React.createRef();
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        const curProps = this.props;
        if (curProps.environment !== nextProps.environment || curProps.platform !== nextProps.platform) {
            this.updateState(nextProps);
        }
    }

    componentDidMount() {
        const { projectId } = this.props;

        this.props.getButtonOptions({ projectId }).then((options) => {
            this.setState({
                btnStyles: this.getBtnStyles(options)
            });
        });
    }

    componentWillUnmount() {
        this.saveBtnOptionsStylePromiseResolve = null;
    }

    updateState(props) {
        const { project, platform, environment, cohorts, selectedCohortId } = props;
        let options = {};
        if (project) {
            options = getProjectOptionsByEnvironment(project, platform, environment, cohorts, selectedCohortId);
        }
        this.setState({
            selectedBtnStyleId: this.getSelectedBtnStyleId(props),
            btnStyles: this.getBtnStyles(props.project.savedOptions),
            ...this.getButtonSettings(options, platform),
        });
    }

    getBtnStyles = (options) => {
        const defaultItem = [{ id: 'default', name: 'Default style' }];

        return [
            ...defaultItem,
            ...options
        ];
    }

    getLogoPropName(btnStateName) {
        return `logo${capitalize(btnStateName)}`;
    }

    getLogoStatePart(options, platform) {
        let logoUrls = this.state?.logoUrls || [];
        const logoIdle = options[this.getLogoPropName(IDLE_STATE)] || this.getLogoUrl(options, platform, IDLE_STATE);
        const logoListen = options[this.getLogoPropName(LISTEN_STATE)] || this.getLogoUrl(options, platform, LISTEN_STATE);
        const logoProcess = options[this.getLogoPropName(PROCESS_STATE)] || this.getLogoUrl(options, platform, PROCESS_STATE);
        const logoReply = options[this.getLogoPropName(REPLY_STATE)] || this.getLogoUrl(options, platform, REPLY_STATE);
        const logoTextChat = options[this.getLogoPropName(TEXT_CHAT_STATE)] || this.getLogoUrl(options, platform, TEXT_CHAT_STATE);
        const logoTextChatAvatar = options[this.getLogoPropName(TEXT_CHAT_AVATAR_STATE)] || this.getLogoUrl(options, platform, TEXT_CHAT_AVATAR_STATE);
        const logoTextChatUserAvatar = options[this.getLogoPropName(TEXT_CHAT_USER_AVATAR_STATE)] || this.getLogoUrl(options, platform, TEXT_CHAT_USER_AVATAR_STATE);

        let logoIdleIndex = 0;
        let logoListenIndex = 1;
        let logoProcessIndex = 1;
        let logoReplyIndex = 1;
        let logoTextChatIndex = 1;
        let logoTextChatAvatarIndex = 1;
        let logoTextChatUserAvatarIndex = 1;

        if (logoUrls.length === 0) {
            if (platform === 'web') {
                logoUrls.push(MIC_BTN_LOGO);
            }
            logoUrls.push(DEFAULT_BTN_LOGO);
            logoUrls.push(USER_AVATAR_LOGO);
        }

        if (logoIdle) {
            if (logoUrls.indexOf(logoIdle) === -1) {
                logoUrls.push(logoIdle);
            }
            logoIdleIndex = logoUrls.indexOf(logoIdle);
        }
        if (logoListen) {
            if (logoUrls.indexOf(logoListen) === -1) {
                logoUrls.push(logoListen);
            }
            logoListenIndex = logoUrls.indexOf(logoListen);
        }
        if (logoProcess) {
            if (logoUrls.indexOf(logoProcess) === -1) {
                logoUrls.push(logoProcess);
            }
            logoProcessIndex = logoUrls.indexOf(logoProcess);
        }
        if (logoReply) {
            if (logoUrls.indexOf(logoReply) === -1) {
                logoUrls.push(logoReply);
            }
            logoReplyIndex = logoUrls.indexOf(logoReply);
        }
        if (logoTextChat) {
            if (logoUrls.indexOf(logoTextChat) === -1) {
                logoUrls.push(logoTextChat);
            }
            logoTextChatIndex = logoUrls.indexOf(logoTextChat);
        }
        if (logoTextChatAvatar) {
            if (logoUrls.indexOf(logoTextChatAvatar) === -1) {
                logoUrls.push(logoTextChatAvatar);
            }
            logoTextChatAvatarIndex = logoUrls.indexOf(logoTextChatAvatar);
        }

        if (logoTextChatUserAvatar) {
            if (logoUrls.indexOf(logoTextChatUserAvatar) === -1) {
                logoUrls.push(logoTextChatUserAvatar);
            }
            logoTextChatUserAvatarIndex = logoUrls.indexOf(logoTextChatUserAvatar);
        }

        logoUrls = logoUrls.filter((v, i) => logoUrls.indexOf(v) === i);

        return {
            [this.getLogoPropName(IDLE_STATE)]: logoIdle,
            [this.getLogoPropName(LISTEN_STATE)]: logoListen,
            [this.getLogoPropName(PROCESS_STATE)]: logoProcess,
            [this.getLogoPropName(REPLY_STATE)]: logoReply,
            [this.getLogoPropName(TEXT_CHAT_STATE)]: logoTextChat,
            [this.getLogoPropName(TEXT_CHAT_AVATAR_STATE)]: logoTextChatAvatar,
            [this.getLogoPropName(TEXT_CHAT_USER_AVATAR_STATE)]: logoTextChatUserAvatar,
            logoUrls: logoUrls,
            [`${IDLE_STATE}LogoUrlIndex`]: logoIdleIndex,
            [`${LISTEN_STATE}LogoUrlIndex`]: logoListenIndex,
            [`${PROCESS_STATE}LogoUrlIndex`]: logoProcessIndex,
            [`${REPLY_STATE}LogoUrlIndex`]: logoReplyIndex,
            [`${TEXT_CHAT_STATE}LogoUrlIndex`]: logoTextChatIndex,
            [`${TEXT_CHAT_AVATAR_STATE}LogoUrlIndex`]: logoTextChatAvatarIndex,
            [`${TEXT_CHAT_USER_AVATAR_STATE}LogoUrlIndex`]: logoTextChatUserAvatarIndex,
        };
    }

    getCurrentButtonColors = () => {
        return {
            idleColor1: this.state.idleColor1,
            idleColor2: this.state.idleColor2,
            listenColor1: this.state.listenColor1,
            listenColor2: this.state.listenColor2,
            processColor1: this.state.processColor1,
            processColor2: this.state.processColor2,
            replyColor1: this.state.replyColor1,
            replyColor2: this.state.replyColor2
        };
    }

    getButtonSettings(options) {
        var colorBtnOptions;

        if (options) {

            colorBtnOptions = options?.btnOptions || defaultOptions;
        } else {
            // for old settings support
            colorBtnOptions = options || defaultOptions;
        }

        let newBtnStateStyle = {
            ...this.getColorStates(colorBtnOptions),
            buttonSize: options?.buttonSize || DEFAULT_ALAN_BTN_SIZE,
            ...this.getLogoStatePart(options),
        };

        return newBtnStateStyle;
    }

    getColorStates = (btnOptions) => {
        let options = btnOptions;

        if (btnOptions && !btnOptions.listen) {
            options = defaultOptions;
        }

        return {
            idleColor1: options.idle.background.color[0],
            idleColor2: options.idle.background.color[1],
            listenColor1: options.listen.background.color[0],
            listenColor2: options.listen.background.color[1],
            processColor1: options.process.background.color[0],
            processColor2: options.process.background.color[1],
            replyColor1: options.reply.background.color[0],
            replyColor2: options.reply.background.color[1],
            textChatColor1: options.textChat ? options.textChat.background.color[0] : defaultOptions.textChat.background.color[0],
            textChatColor2: options.textChat ? options.textChat.background.color[1] : defaultOptions.textChat.background.color[1],
            textChatAvatarColor1: options.textChatAvatar ? options.textChatAvatar.background.color[0] : defaultOptions.textChatAvatar.background.color[0],
            textChatAvatarColor2: options.textChatAvatar ? options.textChatAvatar.background.color[1] : defaultOptions.textChatAvatar.background.color[1],
            textChatUserAvatarColor1: btnOptions.textChatUserAvatar ? btnOptions.textChatUserAvatar.background?.color[0] : (this.state ? this.state[TEXT_CHAT_BUBBLES_REQUEST_BACKGROUND_COLOR_KEY] : getDefaultOptionsValue(this.props.platform, TEXT_CHAT_BUBBLES_REQUEST_BACKGROUND_COLOR_KEY)),
            textChatUserAvatarColor2: btnOptions.textChatUserAvatar ? btnOptions.textChatUserAvatar.background?.color[1] : (this.state ? this.state[TEXT_CHAT_BUBBLES_REQUEST_BACKGROUND_COLOR_KEY] : getDefaultOptionsValue(this.props.platform, TEXT_CHAT_BUBBLES_REQUEST_BACKGROUND_COLOR_KEY)),
        };
    }

    getColorOptions() {
        const {
            idleColor1,
            idleColor2,
            listenColor1,
            listenColor2,
            processColor1,
            processColor2,
            replyColor1,
            replyColor2,
            textChatColor1,
            textChatColor2,
            textChatAvatarColor1,
            textChatAvatarColor2,
            textChatUserAvatarColor1,
            textChatUserAvatarColor2
        } = this.state;

        return {
            idle: {
                background: {
                    color: [idleColor1, idleColor2],
                    angle: 45
                },
                hover: {
                    color: [idleColor1, idleColor2],
                    angle: 45
                },
                shadow: {
                    color: ["#6693bc", "#b3c9de"]
                }
            },

            listen: {
                background: {
                    color: [listenColor1, listenColor2],
                    angle: 45
                },
                hover: {
                    color: [(listenColor1), (listenColor2)],
                    angle: 45
                },
                shadow: {
                    color: [listenColor1, listenColor2]
                }
            },

            process: {
                background: {
                    color: [processColor1, processColor2],
                    angle: 45
                },
                hover: {
                    color: [(processColor1), (processColor2)],
                    angle: 45
                },
                shadow: {
                    color: [processColor1, processColor2]
                }
            },

            reply: {
                background: {
                    color: [replyColor1, replyColor2],
                    angle: 45
                },
                hover: {
                    color: [(replyColor1), (replyColor2)],
                    angle: 45
                },
                shadow: {
                    color: [replyColor1, replyColor2]
                }
            },

            connecting: {
                background: {
                    color: [idleColor1, idleColor2],
                    angle: 45
                },
                hover: {
                    color: ["#1ba3ce", "#1686e5"],
                    angle: 45
                },
                shadow: {
                    color: ["#6693bc", "#b3c9de"]
                }
            },

            offline: {
                background: {
                    color: ["#4e627e", "#5b7491"],
                    angle: 45
                },
                hover: {
                    color: ["#465871", "#5b7491"],
                    angle: 45
                },
                shadow: {
                    color: ["#6693bc", "#b3c9de"]
                }
            },

            noPermission: {
                background: {
                    color: ["#4e627e", "#5b7491"],
                    angle: 45
                },
                hover: {
                    color: ["#465871", "#5b7491"],
                    angle: 45
                },
                shadow: {
                    color: ["#6693bc", "#b3c9de"]
                }
            },

            noConnection: {
                background: {
                    color: ["#4e627e", "#5b7491"],
                    angle: 45
                },
                hover: {
                    color: ["#465871", "#5b7491"],
                    angle: 45
                },
                shadow: {
                    color: ["#6693bc", "#b3c9de"]
                },
                circleColor: "#f1404b"
            },

            serverProblems: {
                background: {
                    color: ["#22cbff", "#1995ff"],
                    angle: 45
                },
                hover: {
                    color: ["#22b6e6", "#1686e6"],
                    angle: 45
                },
                shadow: {
                    color: ["#6693bc", "#b3c9de"]
                }
            },
            textChat: {
                background: {
                    color: [textChatColor1, textChatColor2],
                    angle: 45
                },
                hover: {
                    color: [(textChatColor1), (textChatColor2)],
                    angle: 45
                },
                shadow: {
                    color: ["#6693bc", "#b3c9de"]
                }
            },
            textChatAvatar: {
                background: {
                    color: [textChatAvatarColor1, textChatAvatarColor2],
                    angle: 45
                },
                hover: {
                    color: [(textChatAvatarColor1), (textChatAvatarColor2)],
                    angle: 45
                },
                shadow: {
                    color: ["#6693bc", "#b3c9de"]
                }
            },
            textChatUserAvatar: {
                background: {
                    color: [textChatUserAvatarColor1, textChatUserAvatarColor2],
                    angle: 45
                },
                hover: {
                    color: [(textChatUserAvatarColor1), (textChatUserAvatarColor2)],
                    angle: 45
                },
                shadow: {
                    color: ["#6693bc", "#b3c9de"]
                }
            },
        };
    }

    getLogoUrl(options, platform, btnState) {
        let defaultLogo = btnState === IDLE_STATE ? (platform === 'web' ? MIC_BTN_LOGO : DEFAULT_BTN_LOGO) : DEFAULT_BTN_LOGO;

        if (options[platform]) {
            // case when options come from old alan btn where we supported only one logo prop = "logoUrl"
            if (options.logoUrl &&
                !options[this.getLogoPropName(IDLE_STATE)] &&
                !options[this.getLogoPropName(LISTEN_STATE)] &&
                !options[this.getLogoPropName(PROCESS_STATE)] &&
                !options[this.getLogoPropName(REPLY_STATE)] &&
                !options[this.getLogoPropName(TEXT_CHAT_STATE)] &&
                !options[this.getLogoPropName(TEXT_CHAT_AVATAR_STATE)] &&
                !options[this.getLogoPropName(TEXT_CHAT_USER_AVATAR_STATE)]
            ) {
                return btnState === IDLE_STATE ? MIC_BTN_LOGO : options.logoUrl;
            } else if (btnState) {
                return options[this.getLogoPropName(btnState)] || (btnState === TEXT_CHAT_USER_AVATAR_STATE ? USER_AVATAR_LOGO : defaultLogo);
            }
        }

        if (btnState === TEXT_CHAT_USER_AVATAR_STATE) {
            return USER_AVATAR_LOGO;
        }

        return defaultLogo;
    }

    getSelectedBtnStyleId(props) {
        const { currentOptions } = props;
        return currentOptions?.selectedBtnOptionId || 'default';
    }

    saveBtnOptions = () => {
        const {
            project,
            platform,
            environment,
            cohorts,
            selectedCohortId
        } = this.props;

        const { selectedBtnStyleId } = this.state;

        const options = this.getOptions();
        options[platform].selectedBtnOptionId = selectedBtnStyleId;

        this.props.setProjectOptions({ project, options, environment, cohorts, selectedCohortId }).then(() => {
            ToasterService.showInfo({ title: messages.alanBtnOptionsWereSaved });
        });
    }

    resetToDefault = () => {
        this.resetColorsToDefault();
        this.setState({ buttonSize: DEFAULT_ALAN_BTN_SIZE });
        this.resetCustomLogo(IDLE_STATE);
        this.resetCustomLogo(LISTEN_STATE);
        this.resetCustomLogo(PROCESS_STATE);
        this.resetCustomLogo(REPLY_STATE);
        this.resetCustomLogo(TEXT_CHAT_STATE);
        this.resetCustomLogo(TEXT_CHAT_AVATAR_STATE);
        this.resetCustomLogo(TEXT_CHAT_USER_AVATAR_STATE);
    }

    resetColorsToDefault = () => {
        this.setState({ ...this.getColorStates(defaultOptions) });
    }

    toggleColorPicker = (id, index, e) => {
        const currentColorPickerShownFlag = `${id}ColorPicker${index}Shown`;

        this.closeAllColorPickers();

        this.setState({
            [currentColorPickerShownFlag]: !this.state[currentColorPickerShownFlag],
        });

        if (!this.state[currentColorPickerShownFlag]) {
            this.setState({ currentColorPicker: `${id}Color${index}` });
        }
        cancelEvent(e);
    }

    closeAllColorPickers = (e) => {
        if (e) {
            if (e.target.closest('.sketch-picker')) {
                return;
            }
        }

        this.setState({
            idleColorPicker1Shown: false,
            idleColorPicker2Shown: false,
            listenColorPicker1Shown: false,
            listenColorPicker2Shown: false,
            processColorPicker1Shown: false,
            processColorPicker2Shown: false,
            replyColorPicker1Shown: false,
            replyColorPicker2Shown: false,
            textChatColorPicker1Shown: false,
            textChatColorPicker2Shown: false,
            textChatAvatarColorPicker1Shown: false,
            textChatAvatarColorPicker2Shown: false,
            textChatUserAvatarColorPicker1Shown: false,
            textChatUserAvatarColorPicker2Shown: false
        });
    }

    handleColorPickerChange = (color) => {
        const { currentColorPicker } = this.state;

        if (currentColorPicker) {
            this.setState({ [currentColorPicker]: color }, () => {
                this.handleOptionChanges();
            });
        }
    }

    saveBtnOptionsStyle = () => {
        const saveBtnOptionsPromise = new Promise((resolve, reject) => {
            this.setState({ showSaveBtnOptionsStyleDialog: true });
            this.saveBtnOptionsStylePromiseResolve = resolve;
        });

        return saveBtnOptionsPromise;
    }

    deleteBtnOptionsStyle = (optionsItem) => {
        this.setState({ showDeleteStyleDialog: true, optionsItemForDeleting: optionsItem });
    }

    onBackBtnClick = () => {
        //Case when default style was changed and the named option was not created
        if (this.hasChanges()) {
            this.setState({ showOnBackBtnDialog: true });
            return;
        }

        this.props.onClose();
    }

    hasChanges() {
        const { project, platform, environment, cohorts, selectedCohortId } = this.props;
        const options = getProjectOptionsByEnvironment(project, platform, environment, cohorts, selectedCohortId);

        return !_.isEqual(options[platform], this.getOptions()[platform]);
    }

    saveBtnOptionsStyleAndBtnOptions = () => {
        this.saveBtnOptionsStyle().then((status) => {
            if (status === 'saved') {
                this.saveBtnOptions();
            }
        });
    }

    changeBtnOptionsStyle = ({ id }) => {
        const {
            selectedBtnStyleId,
            btnStyles,
        } = this.state;

        if (selectedBtnStyleId !== id) {
            const selectedBtnStyle = _.find(btnStyles, { id });

            if (this.hasChanges()) {
                this.setState({
                    showOnStyleChangeDialog: true,
                    onStyleChangeDialogOptionsId: id,
                    onStyleChangeDialogNeededOption: selectedBtnStyle
                });
            } else {
                this.finishChangingBtnOption(id, selectedBtnStyle);
            }
        }
    }

    finishChangingBtnOption = (id, selectedBtnStyle) => {
        const { platform } = this.props;
        if (id === 'default') {
            this.resetToDefault();
        }

        if (selectedBtnStyle.options) {
            const options = JSON.parse(selectedBtnStyle.options);
            this.setState({ ...this.getButtonSettings(options, platform) });
        }

        this.setState({ selectedBtnStyleId: id }, () => {
            this.saveBtnOptions();
        });
    }

    renderColorColumn = (btnStateName, disabled) => {
        const { logoUrls } = this.state;
        const stateTitles = {
            [IDLE_STATE]: 'Idle',
            [LISTEN_STATE]: 'Listening',
            [PROCESS_STATE]: 'Processing',
            [REPLY_STATE]: 'Speaking Back',
            [TEXT_CHAT_STATE]: 'Text Chat',
            [TEXT_CHAT_AVATAR_STATE]: <span>AI Assistant Avatar <><ReactTooltip id="assistantAvatarTooltip" />
                <i
                    data-for="assistantAvatarTooltip"
                    data-tip="AI Assistant avatar in full screen mode"
                    data-place="bottom"
                    data-effect="solid"
                    data-class="tutor-light-tooltip tutor-no-arrow-tooltip custom-logo-is-not-available-tooltip"
                    className="icon icon-alan-info-sign"></i></></span>,
            [TEXT_CHAT_USER_AVATAR_STATE]: <span>User Avatar <><ReactTooltip id="userAvatarTooltip" />
                <i
                    data-for="userAvatarTooltip"
                    data-tip="User avatar in full screen mode"
                    data-place="bottom"
                    data-effect="solid"
                    data-class="tutor-light-tooltip tutor-no-arrow-tooltip custom-logo-is-not-available-tooltip"
                    className="icon icon-alan-info-sign"></i></></span>,
        };

        let logoActing = this.state[this.getLogoPropName(btnStateName)];
        let logoIdle = this.state[this.getLogoPropName(IDLE_STATE)];

        const bgColor1 = this.state[`${btnStateName}Color1`];
        const bgColor2 = this.state[`${btnStateName}Color2`];

        return <div className={`alan-button-style-form_btn-state ${disabled ? 'disabled' : ''}`}>
            <div className="alan-button-style-form_btn-state_title">
                {stateTitles[btnStateName]}
            </div>
            <div className={`btn-color-control ${(btnStateName === TEXT_CHAT_USER_AVATAR_STATE || btnStateName === TEXT_CHAT_AVATAR_STATE) ? 'to-left' : 'to-right'}`}>
                <div className={`btn-preview ${btnStateName}`}
                    style={{ backgroundImage: `linear-gradient(135deg, ${bgColor1}, ${bgColor2})` }}>
                    <img src={btnStateName === IDLE_STATE ? (logoIdle || MIC_BTN_LOGO) : (logoActing || DEFAULT_BTN_LOGO)} />
                </div>
                <div>
                    <div className="btn-color-picker picker-1"
                        onClick={(e) => {
                            this.toggleColorPicker(btnStateName, 1, e);
                        }}>
                        <ColorPicker
                            color={bgColor1}
                            onClose={() => { }}
                            onChange={this.handleColorPickerChange}
                            isHex={true}
                            width="100%"
                        />
                    </div>
                </div>
                <div className="sketch-picker-holder-2">
                    <div className="btn-color-picker picker-2"
                        onClick={(e) => {
                            this.toggleColorPicker(btnStateName, 2, e);
                        }}>
                        <ColorPicker
                            color={bgColor2}
                            onClose={() => { }}
                            onChange={this.handleColorPickerChange}
                            isHex={true}
                            width="100%"
                        />
                    </div>
                    {(logoUrls.length > 1) &&
                        <div className="btn-logo-settings">
                            <div
                                className="btn-logo-settings__prev"
                                onClick={() => { this.setCustomLogo(btnStateName, 'prev'); }}>
                                <i className="icon icon-arrow-left" />
                            </div>
                            Choose logo
                            <div
                                className="btn-logo-settings__next"
                                onClick={() => { this.setCustomLogo(btnStateName, 'next'); }}>
                                <i className="icon icon-arrow-right" />
                            </div>
                        </div>}
                </div>
            </div>
        </div>;
    }

    resetCustomLogo = (btnStateName) => {
        this.setState({
            [`${btnStateName}LogoUrlIndex`]: 0,
            [this.getLogoPropName(btnStateName)]: null,
        }, () => {
            this.handleOptionChanges();
        });
    }

    setCustomLogo = (btnStateName, dir) => {
        let logoInd = this.state[`${btnStateName}LogoUrlIndex`];
        let logoUrls = this.state.logoUrls;
        if (dir === 'prev') {
            logoInd = logoInd - 1;
            if (logoInd === -1) {
                logoInd = logoUrls.length - 1;
            }
        }
        if (dir === 'next') {
            logoInd = logoInd + 1;
            if (logoInd === logoUrls.length) {
                logoInd = 0;
            }
        }

        let newLogo = logoUrls[logoInd];

        if (btnStateName === IDLE_STATE && newLogo === MIC_BTN_LOGO) {
            newLogo = null;
        } else if (btnStateName !== IDLE_STATE && newLogo === DEFAULT_BTN_LOGO) {
            newLogo = null;
        }

        this.setState({
            [`${btnStateName}LogoUrlIndex`]: logoInd,
            [this.getLogoPropName(btnStateName)]: newLogo
        }, () => {
            this.handleOptionChanges();
        });
    }

    uploadLogo = () => {
        this.fileInput.current.click();
    }

    getOptions = () => {
        const { project, platform, environment, cohorts, selectedCohortId, currentOptions } = this.props;
        const options = getProjectOptionsByEnvironment(project, platform, environment, cohorts, selectedCohortId);
        const btnStates = [IDLE_STATE, LISTEN_STATE, PROCESS_STATE, REPLY_STATE, TEXT_CHAT_STATE, TEXT_CHAT_AVATAR_STATE, TEXT_CHAT_USER_AVATAR_STATE];
        const {
            buttonSize
        } = this.state;

        let oldLogoUrl = null;

        if (currentOptions) {
            options[platform] = { ...currentOptions };
        }

        for (let i = 0; i < btnStates.length; i++) {
            const curState = btnStates[i];
            const curLogo = this.state[this.getLogoPropName(curState)];
            let defLogo = curState === IDLE_STATE ? (platform === 'web' ? MIC_BTN_LOGO : DEFAULT_BTN_LOGO) : DEFAULT_BTN_LOGO;
            if (curState === TEXT_CHAT_USER_AVATAR_STATE) {
                defLogo = USER_AVATAR_LOGO;
            }

            if (curLogo !== null && curLogo !== defLogo) {
                options[platform][this.getLogoPropName(curState)] = curLogo;
                if (!oldLogoUrl) {
                    oldLogoUrl = curLogo;
                }
            } else {
                delete options[platform][this.getLogoPropName(curState)];
            }
        }

        if (oldLogoUrl) {
            options[platform].logoUrl = oldLogoUrl;
        } else {
            delete options[platform].logoUrl;
        }

        if (buttonSize !== DEFAULT_ALAN_BTN_SIZE) {
            options[platform].buttonSize = buttonSize;
        } else {
            delete options[platform].buttonSize;
        }

        if (JSON.stringify(this.getColorStates(defaultOptions)) !== JSON.stringify(this.getColorStates(this.getColorOptions()))) {
            options[platform].btnOptions = this.getColorOptions();
        } else {
            delete options[platform].btnOptions;
        }

        return options;
    }

    saveOptions = () => {
        const { project, environment, cohorts, selectedCohortId } = this.props;
        const options = this.getOptions();
        console.info('options', options);
        this.props.setProjectOptions({
            project,
            options,
            environment,
            cohorts,
            selectedCohortId
        });
    }

    onFileChanged = () => {
        const { projectId, platform, uploadAlanBtnLogo } = this.props;
        const files = this.fileInput.current.files;
        const filesToUpload = [];

        const arrayOfNotSquareImgs = [];
        const _URL = window.URL || window.webkitURL;
        const imgSizePromises = [];

        if (files.length === 0) {
            return;
        }

        for (let i = 0; i < files.length; i++) {
            imgSizePromises.push($.Deferred());
        }

        for (let i = 0; i < files.length; i++) {
            const file = files[i];
            const img = new Image();
            const objectUrl = _URL.createObjectURL(file);
            img.onload = function () {
                if (this.width !== this.height) {
                    arrayOfNotSquareImgs.push(file);
                } else {
                    filesToUpload.push(file);
                }
                _URL.revokeObjectURL(objectUrl);
                imgSizePromises[i].resolve();
            };
            img.src = objectUrl;
        }

        Promise.all(imgSizePromises).then(() => {
            if (arrayOfNotSquareImgs.length > 0) {
                let msg;
                let badImages = `${arrayOfNotSquareImgs.map(file => `<b>${file.name}</b>`).join(', ')}`;
                if (arrayOfNotSquareImgs.length > 0) {
                    msg = `The following images are not in square shape: ${badImages}. They won't be uploaded. `;
                } else {
                    msg = `The following image is not in square shape: ${badImages}. It won't be uploaded. `;
                }
                msg += 'Please, upload only images that fit image requirements.';
                ToasterService.showWarning({
                    title: msg
                });
            }

            if (filesToUpload.length === 0) {
                return;
            }

            this.setState({ uploadingLogo: true });

            uploadAlanBtnLogo({
                projectId,
                platform,
                files: filesToUpload,
            }).then((urls) => {
                if (urls && urls.length >= 1) {
                    this.setState({
                        logoUrls: [...this.state.logoUrls, ...urls],
                        uploadingLogo: false
                    });
                }
            }, () => {
                this.setState({ uploadingLogo: false });
            });
        });
    }

    renderThumbs = (props, state) => {
        return <div {...props}>
            <div className="slider-tooltip">
                {state.valueNow}px
            </div>
        </div>;
    };

    onButtonSizeChange = (buttonSize) => {
        this.setState({
            buttonSize,
        }, () => {
            this.handleOptionChanges();
        });
    }

    handleOptionChanges = _.debounce(() => {
        this.props.onOptionsChange(this.getOptions()[this.props.platform]);
    }, 500)

    render() {
        const {
            isProjectOptionsSaving,
            onClose,
            deleteButtonOptions,
            addButtonOptions,
            project,
            platform,
            capabilities
        } = this.props;

        const {
            selectedBtnStyleId,
            btnStyles,
            showOnBackBtnDialog,
            showDeleteStyleDialog,
            showOnStyleChangeDialog,
            optionsItemForDeleting,
            showSaveBtnOptionsStyleDialog,
            onStyleChangeDialogOptionsId,
            onStyleChangeDialogNeededOption,
            uploadingLogo,
            logoUrls,
            buttonSize
        } = this.state;

        const header = `${platformNames[platform]} - Button Style`;
        const hasUnsavedChanges = this.hasChanges();
        const withCustomButtonLogo = capabilities.customButtonLogo;
        const noCustomButtonLogoFeatureTooltip = messages.featureNotAvailable;
        const textChatIsAvailable = this.state[TEXT_CHAT_ENABLED_KEY];
        const fullScreenIsAvailable = this.state[TEXT_CHAT_POPUP_FULL_SCREEN_MODE_ENABLED_KEY];

        let textChatTooltipText = null;

        if (!textChatIsAvailable) {
            textChatTooltipText = 'Enable Text Chat to activate options below';
        } else if (textChatIsAvailable && !fullScreenIsAvailable) {
            textChatTooltipText = 'Enable Full screen mode option in Text Chat settings to activate options for user and AI assistance avatars';
        }

        //todo: recheck form

        return <div className={`alan-button-style-form`}>
            <style>
                {`
                .alan-btn__user-avatar path {
                    fill: ${this.state[TEXT_CHAT_BUBBLES_RESPONSE_FONT_COLOR_KEY]};
                }
                `}
            </style>
            <div className=""
                onClick={this.closeAllColorPickers}>

                <div className="">
                    <div
                        className="alan-button-style-form_btn-previews"
                        ref="bgColorPickerContainer">

                        <div className="alan-button-style-form_btn-group">
                            <div className="alan-button-style-form_btn-group_header">Voice States
                                {textChatIsAvailable && <><ReactTooltip id="voiceStateTooltip" />
                                    <i
                                        data-for="voiceStateTooltip"
                                        data-tip="Disable Text Chat setting to activate this options"
                                        data-place="bottom"
                                        data-effect="solid"
                                        data-class="tutor-light-tooltip tutor-no-arrow-tooltip custom-logo-is-not-available-tooltip"
                                        className="icon icon-alan-info-sign"></i></>}</div>
                            <div className={`alan-button-style-form_btn-group_cols voice`}>
                                {this.renderColorColumn(IDLE_STATE, textChatIsAvailable)}
                                {this.renderColorColumn(LISTEN_STATE, textChatIsAvailable)}
                                {this.renderColorColumn(PROCESS_STATE, textChatIsAvailable)}
                                {this.renderColorColumn(REPLY_STATE, textChatIsAvailable)}
                            </div>
                        </div>

                        <div className="alan-button-style-form_btn-group">
                            <div className="alan-button-style-form_btn-group_header">Text Chat
                                {textChatTooltipText && <><ReactTooltip id="textChatStateTooltip" />
                                    <i
                                        data-for="textChatStateTooltip"
                                        data-tip={textChatTooltipText}
                                        data-place="bottom"
                                        data-effect="solid"
                                        data-class="tutor-light-tooltip tutor-no-arrow-tooltip custom-logo-is-not-available-tooltip"
                                        className="icon icon-alan-info-sign"></i></>}</div>
                            <div className={`alan-button-style-form_btn-group_cols text-chat `}>
                                {this.renderColorColumn(TEXT_CHAT_STATE, !textChatIsAvailable)}
                                {this.renderColorColumn(TEXT_CHAT_USER_AVATAR_STATE, !(textChatIsAvailable && fullScreenIsAvailable))}
                                {this.renderColorColumn(TEXT_CHAT_AVATAR_STATE, !(textChatIsAvailable && fullScreenIsAvailable))}
                            </div>
                        </div>
                    </div>


                    <div className="alan-button-style-form__row">
                        <div className="alan-button-style-form__col">
                            <div className="alan-button-style-form__button-size">
                                <div className="alan-button-style-form__slider-cont">
                                    <div className="alan-button-style-form__title">
                                        Button size, px
                                    </div>
                                    <div className="alan-button-style-form__btn-size-slider">
                                        <Slider
                                            key={selectedBtnStyleId}
                                            min={32}
                                            step={1}
                                            value={buttonSize}
                                            onChange={this.onButtonSizeChange}
                                            onAfterChange={this.onButtonSizeChange}
                                            max={96}
                                            renderThumb={this.renderThumbs}
                                            scale={
                                                <div className="slider-scale">
                                                    {BTN_SIZE_SLIDER_OPTIONS.map((scaleUnit, index) => {
                                                        return <div className="slider-scale-unit-cont" key={index}>
                                                            <div className="slider-scale-unit">
                                                                {scaleUnit !== 0 &&
                                                                    <div className="slider-scale-label">
                                                                        {scaleUnit}
                                                                    </div>}
                                                            </div>
                                                        </div>;
                                                    })}
                                                </div>
                                            }
                                        />
                                    </div>
                                </div>
                                <div className="alan-button-style-form__logo-size">
                                    <div className={`btn-preview ${IDLE_STATE} alan-button-style-form__logo-cont`}
                                        style={{
                                            backgroundImage: !textChatIsAvailable ? `linear-gradient(135deg, ${this.state.idleColor1}, ${this.state.idleColor2})` : `linear-gradient(135deg, ${this.state.textChatColor1}, ${this.state.textChatColor2})`,
                                            height: `${buttonSize}px`,
                                            width: `${buttonSize}px`,
                                        }}>
                                        <img
                                            className="alan-button-style-form__logo-image"
                                            src={(this.state[this.getLogoPropName(textChatIsAvailable ? TEXT_CHAT_STATE : IDLE_STATE)] || MIC_BTN_LOGO)} />
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="alan-button-style-form__col">
                            <div className="alan-button-style-form_logo-settings">
                                <div className="alan-button-style-form__title">
                                    Logos settings {!withCustomButtonLogo && <i
                                        className="icon icon-alan-help-sign"
                                        data-for="customLogoIsNotAvailable"
                                        data-tip={noCustomButtonLogoFeatureTooltip}
                                        data-place="bottom"
                                        data-effect="solid"
                                        data-class="tutor-light-tooltip tutor-no-arrow-tooltip custom-logo-is-not-available-tooltip" />}</div>
                                <ReactTooltip id="customLogoIsNotAvailable" />
                                <div className="alan-button-style-form_custom-logos">
                                    {logoUrls.map(logoUrl => <div key={logoUrl}><img src={logoUrl} /></div>)}
                                </div>
                                <div className="alan-button-style-form_logo-settings_content">
                                    <div className="alan-button-style-form_logo-settings_btns">
                                        <div
                                            onClick={withCustomButtonLogo ? this.uploadLogo : undefined}
                                            className={`action-btn light-blue-with-border upload-logo-btn ${!withCustomButtonLogo && 'disabled'}`}>{uploadingLogo ? 'Adding...' : 'Add custom logos'}</div>
                                        <input style={{ display: 'none' }} multiple type="file" ref={this.fileInput} onChange={this.onFileChanged} accept=".png,.gif,.svg" />
                                    </div>
                                </div>
                                <div className={`alan-button-style-form_logo-settings_info ${!withCustomButtonLogo && 'disabled'}`}>
                                    Image requirements: an image must be square in shape in the .png, .svg or .gif format with some transparent areas on the sides. The optimal image size is 400 x 400 pixels.
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>;
    }
}

function mapStateToProps({ projectsInfo, user }) {
    return {
        isProjectOptionsSaving: projectsInfo.isProjectOptionsSaving,
        capabilities: user.capabilities
    };
}

function mapDispatchToProps(dispatch) {
    return {
        getButtonOptions: (param) => asyncDispatch(actions.getButtonOptions, dispatch, param),
        setProjectOptions: (param) => asyncDispatch(actions.setProjectOptions, dispatch, param),
        uploadAlanBtnLogo: (param) => asyncDispatch(actions.uploadAlanBtnLogo, dispatch, param),
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(AlanButtonStyleForm);
